import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

const DraggableItem = ({ children, idx, moveItem, hasWritePerm, type, sx = {} }) => {
    const ref = useRef(null);

    const [, drop] = useDrop({
        accept: type,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) return;

            const dragIdx = item.idx;
            const hoverIdx = idx;

            if (dragIdx === hoverIdx) return;

            const hoverBoundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();

            if (!clientOffset) return;

            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIdx < hoverIdx && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIdx > hoverIdx && hoverClientY > hoverMiddleY) {
                return;
            }

            moveItem(dragIdx, hoverIdx);
            item.idx = hoverIdx;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: type,
        item: () => ({ idx }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        canDrag: () => hasWritePerm,
    });

    drag(drop(ref));

    const baseStyle = {
        opacity: isDragging ? 0.5 : 1,
        cursor: hasWritePerm ? 'move' : 'default',
        margin: '1rem 0',
        paddingLeft: '1rem',
        ...sx,
    };

    return (
        <div ref={ref} style={baseStyle}>
            {children}
        </div>
    );
};

export default DraggableItem;